import { EmotionCache } from '@emotion/cache';
import createEmotionServer from '@emotion/server/create-instance';
import { defaultDailyshotEmotionCache } from '@dailyshot/styles';

export function createStylesServer(cache?: EmotionCache) {
  return createEmotionServer(cache || defaultDailyshotEmotionCache);
}
